import { get as originalGet, post as originalPost, patch as originalPatch, destroy as originalDestroy } from "@rails/request.js"
import appsignal from "@lib/appsignal"
import { currentUser } from "@lib/utils"

const AUTH_STATUS_CODES = [401, 403]

function logAuthError(response, url, extraTags = {}) {
  try {
    const span = appsignal.createSpan()
    span.setAction("auth-error")
    span.setNamespace("requests")
    span.setTags({
      user: currentUser(),
      status: response?.status,
      url,
      location_path: window.location.pathname,
      ...extraTags,
    })
    span.setError(new Error(`Auth error ${response?.status} for ${url}`))
    appsignal.send(span)
  } catch (e) {
    // Swallow any logging errors – we never want to break the request flow
    console.error("Error logging auth error", e)
  }
}

function redirectToLogin() {
  window.location.href = "/users/sign_in"
}

async function handleRequest(requestFn, url, options = {}) {
  const response = await requestFn(url, options)

  // Auth errors: always go to login
  if (AUTH_STATUS_CODES.includes(response.status)) {
    // logAuthError(response, url)
    redirectToLogin()
    return null
  }

  // Distinguish between *real* CSRF/session expiry and "normal" 422s
  // Real CSRF/session expiry is signalled by a 422 **with** the X-Session-Expired header
  if (response.status === 422) {
    const markedAsExpired = response.headers.get("X-Session-Expired") === "1"

    if (markedAsExpired) {
      // This is the CSRF/session case coming from ApplicationController#handle_invalid_csrf_token
      const errorMessage = "422: Session marked as expired (CSRF invalid)"
      logAuthError(response, url, { markedAsExpired, kind: "csrf", message: errorMessage })

      // Force user back to login – at this point the Rails side has already reset the session
      redirectToLogin()
      return null
    }

    // Plain 422 without the header – this is most likely a normal validation error.
    // Let the caller inspect response.json / response.ok instead of swallowing it here.
    return response
  }

  // Any other non‑OK HTTP error
  // if (!response.ok) {
  //   logAuthError(response, url, { kind: "http-error" })
  //   return null
  // }

  return response
}

export function get(url, options = {}) {
  return handleRequest(originalGet, url, options)
}

export function post(url, options = {}) {
  return handleRequest(originalPost, url, options)
}

export function patch(url, options = {}) {
  return handleRequest(originalPatch, url, options)
}

export function destroy(url, options = {}) {
  return handleRequest(originalDestroy, url, options)
}
